import { Link } from "react-router-dom";
import { Reveal } from "../lib/reveal";
import { caseStudies } from "../data/caseStudies";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const CaseStudiesTeaser = () => {
  const { t } = useLang();
  const items = caseStudies.slice(0, 3);
  return (
    <section id="case-studies" data-testid="case-studies-teaser" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <Reveal className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-[0.22em] uppercase font-semibold text-moss">{t("Case Studies", "केस स्टडी")}</span>
            </Reveal>
            <Reveal>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-ink">
                {t("Before & after, across India.", "पहले व बाद में, पूरे भारत में।")}
              </h2>
            </Reveal>
          </div>
          <Reveal>
            <Link to="/case-studies" data-testid="view-all-cases" className="inline-flex items-center gap-2 rounded-full border border-stone/30 px-6 py-3 text-sm tracking-[0.08em] uppercase hover:bg-sand transition-colors duration-300">
              {t("View all deployments", "सभी तैनातियाँ देखें")} <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.08}>
              <Link to={`/case-studies/${c.slug}`} data-testid={`case-card-${c.slug}`} className="group block h-full bg-bone rounded-3xl border border-stone/20 overflow-hidden hover:border-moss transition-colors duration-400">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={c.afterImg} alt={`${c.city} after OED treatment`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute top-4 left-4 text-[0.68rem] tracking-[0.16em] uppercase bg-bone/90 text-forest px-3 py-1.5 rounded-full">{c.tag}</span>
                </div>
                <div className="p-7">
                  <div className="text-xs tracking-[0.12em] uppercase text-stone">{c.region}</div>
                  <h3 className="font-serif text-2xl mt-2 mb-3 text-ink leading-tight">{t(c.headline, c.hi?.headline)}</h3>
                  <div className="flex flex-wrap gap-4 mt-5">
                    {c.metrics.slice(0, 2).map((m) => (
                      <div key={m.k}>
                        <div className="font-serif text-2xl text-moss leading-none">{m.v}</div>
                        <div className="text-[0.68rem] tracking-[0.1em] uppercase text-stone mt-1">{m.k}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
